// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

export const useIsLibraryFilterNavOpen = () => useAppSelector(state => state.store.data.cmsLibrary.isFilterNavOpen);
